
<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
<section class="blog_area section_padding_0_80">
    <div class="container3 cent" style="margin-top:60px !important">
        <div class="row" *ngIf="blog && blog.length> 0; else noblogFound">
            <div class="col-sm-12 col-md-6 col-lg-8 col-xl-8">
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6" *ngFor="let data of blog | pettypefilter: pettypefilterid |
                  breedfilter: breedfilterid | lifestageblog: lifestagefilterid">
                      <div class="single-post wow fadeInUp" data-wow-delay=".2s">
                          <div class="post-thumb">
                              <img style="width:100%; max-height:200px" src="https://passport.petcart.in/images/blogimage/{{data.blogcoverimg}}" alt="">
                          </div>
                          <div class="post-content">
                              <div class="post-meta d-flex">
                                  <div class="post-author-date-area d-flex">
                                      <!-- Post Author -->
                                      <div class="post-author">
                                          <a href="#">By Petcart</a>
                                      </div>
                                      <!-- Post Date -->
                                      <div class="post-date">
                                          <a href="#">{{data.created_at | slice:0:10}}</a>
                                      </div>
                                  </div>
                                  <!-- Post Comment & Share Area -->
                                  <div class="post-comment-share-area d-flex">
                                      <!-- Post Comments -->
                                      <div class="post-comments">
                                          <a href="#"><i class="fa fa-comment-o" aria-hidden="true"></i>{{commentsarray['id' + data.id]}} </a>
                                      </div>
                                      <!-- Post Share -->
                                      <div class="post-share">
                                          <a href="#"><i class="fa fa-share-alt" aria-hidden="true"></i></a>
                                      </div>
                                  </div>
                              </div>
                              <a>
                                  <h2 class="post-headline">{{data.title}}</h2>
                              </a>
                              <p [innerHTML]="data.body | slice: 0: 200"></p>
                              <a  class="read-more" (click)="goTodetail(data.id , data.url)">Continue Reading..</a>
                          </div>
                          </div>
                  </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
               <div class="card" style="border-radius:30px;border: 1px solid #cd983f;">
                  <div class="filter-header text-center" style="    border-radius: 20px 20px 0 0;">
                 Categories
                </div>
                <div *ngIf="allblogs && allblogs.length > 0">
                        <div *ngFor="let datan of allblogs | uniquefilter2 : 'category'">
                            <p class="filterel"  (click)="refreshmaincategory(datan.category)">{{datan.category}} ({{categoryCount(datan.category)}})</p>
                       </div>
                      </div>

                      <div *ngIf="breed && allblogs  && type === 'all';else otherpettype">
                            <div class="filter-header text-center">
                                    Pet Type
                     </div>
                          <div  *ngFor= "let data of breed">
                             <div *ngFor="let datan of allblogs | uniquefilter2 : 'pet_type'">
                               <div *ngIf="datan.pet_type == data.id" >
                                 <p class="filterel" (click)=" refreshPetType(data.id)" >{{data.name}} ({{pettypeCount(datan.pet_type)}})</p>
                            </div>
                           </div>
                         </div>
                       </div>


                   <div *ngIf="breed && allblogs  && type === 'all'; else otherbreed">
                        <div class="filter-header text-center" >
                                Breed
                                 </div>
                   <div  *ngFor= "let data of breed">
                      <div *ngFor="let datan of allblogs | uniquefilter2 : 'breed_id'">
                        <div *ngIf="data.id === datan.breed_id">
                          <p class="filterel" (click)="refreshBreed(data.id)">{{data.name}} ({{breedCount(datan.breed_id)}})</p>
                     </div>
                    </div>
                  </div>
                </div>

                      <div *ngIf="lifestage && allblogs  && type === 'all'; else otherlifestage">
                            <div class="filter-header text-center" >
                                    Pet Lifestage
                                     </div>
                          <div  *ngFor= "let data of lifestage">
                             <div *ngFor="let datan of allblogs  | uniquefilter2 : 'lifestage_id'">
                               <div *ngIf="datan.lifestage_id == data.id">
                                 <p class="filterel" (click)="refreshLifestage(data.id)">{{data.name}} ({{lifestageCount(datan.lifestage_id)}})</p>
                            </div>
                           </div>
                         </div>
                       </div>
              </div>
            </div>
          </div>
    </div>
    </section>
  <ng-template #otherpettype>

    <div *ngIf="breed && blog">
            <div class="filter-header text-center" *ngIf="pcount > 0" >
                    Pet Type
            </div>
        <div  *ngFor= "let data of breed">
           <div *ngFor="let datan of blog | uniquefilter2 : 'pet_type'">
             <div *ngIf="data.id === data" >
               <p class="filterel" (click)=" setPetTypeFilter(data.id)" >{{data.name}} ({{pettypeCount2(data.id)}})</p>
          </div>
         </div>
       </div>
     </div>
  </ng-template>
  <ng-template #otherbreed>
    <div *ngIf="breed && blog">
            <div class="filter-header text-center" *ngIf=" bcount > 0" >
                    Breed
                     </div>
        <div  *ngFor= "let data of breed">
           <div *ngFor="let datan of blog | uniquefilter2 : 'breed_id'">
             <div *ngIf="data.id === datan.breed_id">
               <p class="filterel" (click)="setBreedFilter(data.id)">{{data.name}} ({{breedCount2(data.id)}})</p>
          </div>
         </div>
       </div>
     </div>
</ng-template>
<ng-template #otherlifestage>
    <div *ngIf="lifestage && blog" >
            <div class="filter-header text-center" *ngIf=" lcount > 0 " >
                    Pet Lifestage
                     </div>
        <div  *ngFor= "let data of lifestage">
           <div *ngFor="let datan of blog  | uniquefilter2 : 'lifestage_id'">
             <div *ngIf="data.id === datan.lifestage_id">
               <p class="filterel" (click)="setLifestageFilter(data.id)">{{data.name}} ({{lifestageCount2(data.id)}})</p>
          </div>
         </div>
       </div>
     </div>
</ng-template>
<ng-template #noblogFound>
    <div class="row" style="margin-top:10px" *ngIf="found === 0 && blog.length === 0">

                <div class="col-12 text-center">
                        <div class="card-header">
                        <h4 style="color:#9b7544; font-style: open sans">No Blogs Found</h4>
                    </div>
                    </div>
        </div>


</ng-template>
